var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarAccountActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.398 13.16c3.087 0 5.536 2.743 5.536 6.07v1.258c0 .574-.467 1.039-1.042 1.039H4.042c-.575 0-1.042-.465-1.042-1.039V19.23c0-3.327 2.45-6.07 5.536-6.07h7.862zM12.468 2c2.696 0 4.879 2.195 4.879 4.897 0 2.703-2.183 4.897-4.88 4.897S7.587 9.6 7.587 6.897C7.588 4.195 9.77 2 12.468 2z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarAccountActive);
export default __webpack_public_path__ + "static/media/navbar-account-active.a2cf22340557e5941260f2c9a72051ba.svg";
export { ForwardRef as ReactComponent };